export default __webpack_public_path__ + "static/data-quote-simon-james--mobile-20d6325fd066d3bce39ff718f2cda681.webp";